import { dbAnotadorInstance } from "../database/db";
import { Document } from "../objects/Document.interface";


export class DocumentService{
    constructor (){}

    getList(projectId:number){
        const result = dbAnotadorInstance.documents.where({projectId:projectId}).toArray();
        return result;
    }

    getAll(){
        const result = dbAnotadorInstance.documents.toArray();
        return result;
    }

    getDocument(docId:number){
        const result = dbAnotadorInstance.documents.where({id: docId}).toArray();
        return result;
    }

    add(document:Document){
        const result = dbAnotadorInstance.documents.add(document);
        return result;
    }

    delete(document:Document){
        dbAnotadorInstance.annotations.where({documentId: document.id}).delete().then(res => { console.log(res); });
          
        const result = dbAnotadorInstance.documents.delete(document.id);
        return result;
    }

    update(document:Document){
        const result = dbAnotadorInstance.documents.update(document.id!, {
                        title: document.title,
                        isSelected: document.isSelected,
                        sort: document.sort,
                        placeNames: document.placeNames});
        return result;
    }

    updateBulk(documentList:Document[])
    {
        var documentsUpdate:any[] = [];
        documentList.forEach((document) =>
            {

                documentsUpdate.push({
                    key:document.id,
                    changes: {
                        id: document.id,
                        title: document.title,
                        textContent: document.textContent,
                        projectId: document.projectId,
                        isSelected: document.isSelected,
                        sort: document.sort,
                        placeNames: document.placeNames
                    }
                });
            }
        );
        const result = dbAnotadorInstance.documents.bulkUpdate(documentsUpdate);
        return result;
    }
}